import { Pipe, PipeTransform } from '@angular/core';
import { formatarGenero } from '../../utilities/format-gender';

@Pipe({
  name: 'formatGender'
})
export class GenderPipe implements PipeTransform {

  transform(value: unknown): string {
    return formatarGenero(value);
  }
}
